import React from 'react';
import { Text } from '@fluentui/react/lib/Text';
import DialogTemplate from '../../../Common/DialogTemplate';

interface IRuleErrorDialog {
  showPopUp: boolean;
  setShowPopUp: (val: boolean) => void;
}

const RuleErrorDialog = ({ showPopUp
    ,setShowPopUp }: IRuleErrorDialog) => {
  return (
    <DialogTemplate
      showDialog={showPopUp}
      toggleShowDialog={()=>setShowPopUp(false)}
      title={`No se ha podido agregar al jugador.`}
      onAccept={()=>setShowPopUp(false)}
      onCancel={()=>{}}
      hideCancelButton
      acceptText="Ok"
      cancelText=""
      minWidth={600}
    >
      <Text className="error-message" variant="medium">Se alcanzó la cantidad máxima permitida de jugadores de esa categoría.</Text>
    </DialogTemplate>
  );
};

export default RuleErrorDialog;
